/* eslint-disable import/no-default-export */
import React from 'react';

const CommentIcon = (props) => (
  <svg width={13} height={11} viewBox="0 0 13 11" {...props}>
    <path
      fill={props.color || 'currentColor'}
      d="M3.631 8.177l1.555-.668.365.027c.175.012.344.019.51.019 2.554 0 4.468-1.372 4.468-2.778S8.615 2 6.06 2C3.505 2 1.592 3.371 1.592 4.777c0 .686.458 1.392 1.337 1.945l.702.44v1.015zM6.061.5c3.295 0 5.968 1.915 5.968 4.277 0 2.363-2.673 4.278-5.969 4.278-.208 0-.414-.008-.618-.023l-3.311 1.422V7.992C.884 7.207.091 6.06.091 4.777.092 2.415 2.765.5 6.062.5z"
    />
  </svg>
);

export default CommentIcon;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/icons/CommentIcon.js